import deepcopy from "deepcopy";
export var removeNulls = function (obj) {
  if (obj === null || typeof obj === 'string' && obj === '') {
    return undefined;
  }
  if (typeof obj === 'object') {
    var copy = deepcopy(obj);
    for (var key in copy) {
      copy[key] = removeNulls(copy[key]);
    }
    return copy;
  }
  return obj;
};